import React from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../intelligence-briefing-library/components/ui/tooltip";

const TOOLTIP_CLASS =
  "z-[9999] w-[280px] border border-gray-200 bg-white px-3.5 py-3 font-normal normal-case tracking-normal text-gray-800 shadow-[0_4px_16px_rgba(0,0,0,0.12)]";

/** Hover explanation for a live, not-yet-published level on an open round. */
export const ProvisionalLevelTooltip: React.FC<{
  children: React.ReactElement;
}> = ({ children }) => (
  <TooltipProvider delayDuration={150}>
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        side="bottom"
        align="start"
        sideOffset={8}
        className={TOOLTIP_CLASS}
      >
        <p className="mb-1 text-[13px] font-semibold text-gray-900">
          Provisional level
        </p>
        <p className="mb-0 text-[12.5px] leading-snug text-gray-600">
          Median of each member&apos;s newest current input. It updates as
          people submit and becomes the published level when the round closes,
          unless a disconnect changes it.
        </p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
